export default __webpack_public_path__ + "static/media/Check your email.5c9600af.svg";